moment = require('moment')

module.exports = () ->
  return {
    restrict: "A"
    scope:
      maxDate: "&?"
      minDate: "&?"
      ngRequired: "&?"
      disabled: "&arachnysDatePickerDisabled"
    require: "ngModel"

    controller: (
      $scope,
      arachnysDatePickerOutputFormat,
      arachnysMinDate,
      arachnysMaxDate
    ) ->

      maxDate = moment(arachnysMaxDate).toDate()
      minDate = moment(arachnysMinDate).toDate()

      inputMinDate = $scope.minDate && $scope.minDate()
      inputMaxDate = $scope.maxDate && $scope.maxDate()

      $scope.getMaxDate = ->
        return inputMaxDate || maxDate

      $scope.getMinDate = ->
        return inputMinDate || minDate

      $scope.datePickerOptions =
        showWeeks: false
      $scope.dateFormat = arachnysDatePickerOutputFormat

    link: (
      scope,
      element,
      attrs,
      outerNgModelController
    ) ->

      scope.model =
        inner: outerNgModelController.$modelValue

      # Pipe "inner" model changes to the "outer" model
      unreg = scope.$watch "forms.form.innerNgModelController", (innerNgModelController) ->
        if innerNgModelController
          unreg()
          innerNgModelController.$parsers.push (innerViewValue) ->
            outerNgModelController.$setViewValue(innerViewValue)
            return innerViewValue

      # Pipe "outer" model changes to the "inner" model,
      # and format as a Date
      outerNgModelController.$formatters.push (outerModelValue) ->
        scope.model.inner = if outerModelValue then moment(outerModelValue).toDate() else null

      # Format the "outer" model as a string
      outerNgModelController.$parsers.push (outerViewValue) ->
        return if outerViewValue then moment(outerViewValue).format("YYYY-MM-DD") else undefined

    template: require("./date-picker.html")
  }
